<template>
  <div>
    <!-- 使用 ResumeInfo 组件 -->
    <div class="resume-info-wrapper">
      <ResumeInfo
        ref="resumeInfoRef"
        :visible="true"
        :value="resumeData"
        :isParsed="false"
        title="个人详细信息"
        :show-edit-buttons="true"
        :no-card-style="true"
        :show-expectation-fields="false"
        :editable="false"
        @input="handleResumeDataChange"
        @save-success="handleSaveSuccess"
      />
    </div>

    <!-- 求职期望部分 -->
    <div class="job-expectations-section">
      <div class="section-header">
        <h3 class="section-title">求职期望</h3>
        <el-button type="primary" class="add-btn" @click="addJobExpectation">
          <img src="./assets/img/add.png" class="btn-icon" />
          添加求职期望
        </el-button>
      </div>
      
      <div class="expectations-content">
        <div 
          v-for="(expectation, index) in jobExpectations" 
          :key="index" 
          class="expectation-card"
        >
          <div class="expectation-info">
            <div class="expectation-item">
              <span class="expectation-label">求职类型:</span>
              <span class="expectation-value">{{ getJobTypeLabel(expectation.job_type) }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">期望职位:</span>
              <span class="expectation-value" :title="expectation.job_objective">{{ expectation.job_objective }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">工作地点:</span>
              <span class="expectation-value">{{ expectation.desired_city }}</span>
            </div>
            <div class="expectation-item">
              <span class="expectation-label">期望薪资:</span>
              <span class="expectation-value">{{ formatExpectationSalary(expectation) }}</span>
            </div>
          </div>
          
          <div class="expectation-actions">
            <el-button type="text" class="edit-expectation-btn" @click="editJobExpectation(index)">
              <img src="./assets/img/edit.png" class="btn-icon" />
              编辑
            </el-button>
            <el-button type="text" class="delete-expectation-btn" @click="deleteJobExpectation(index)">
              <img src="./assets/img/delete.png" class="btn-icon" />
              删除
            </el-button>
          </div>
        </div>
      </div>
    </div>


    <!-- 添加/编辑求职期望对话框 -->
    <JobExpectationDialog
      :visible.sync="editExpectationDialogVisible"
      :editing-data="currentEditingExpectation"
      @submitted="onExpectationSaved"
      @close="resetExpectationDialog"
    />
  </div>
</template>

<script>
import { getJobTypeLabel } from '@/constants/jobConstants'
import { getUserExpectList, deleteUserExpect, getUserExpectDetail } from '@/api/user'
import JobExpectationDialog from '@/components/JobExpectationDialog/index.vue'
import ResumeInfo from '@/views/dashboards/components/ResumeInfo.vue'

export default {
  name: 'PersonalBasic',
  components: {
    JobExpectationDialog,
    ResumeInfo
  },
  props: {
    userInfo: {
      type: Object,
      default: () => ({
        real_name: '',
        email: '',
        mobile: '',
        date_of_birth: '',
        desired_city: '',
        expected_salary: '',
        education_list: [],
        work_experience_list: [],
        project_list: [],
        award_list: [],
        personal_profile: ''
      })
    }
  },
  data() {
    return {
      // ResumeInfo 组件的数据
      resumeData: {
        real_name: '',
        email: '',
        mobile: '',
        date_of_birth: '',
        desired_city: '',
        expected_salary: '',
        education_list: [],
        work_experience_list: [],
        project_list: [],
        award_list: [],
        personal_profile: ''
      },
      // 求职期望数据
      jobExpectationData: {
        id: '',
        job_type: '',
        desired_city: '',
        expected_salary_start: '',
        expected_salary_end: '',
        job_objective: ''
      },
      // 求职期望列表
      jobExpectations: [],
      // 对话框控制
      editPersonalDialogVisible: false,
      editExpectationDialogVisible: false,
      editingExpectationIndex: null,
      currentEditingExpectation: null,
      // 备份原始数据（当 showEditButtons 为 true 时，由 ResumeInfo 组件内部管理）
      originalResumeData: null
    };
  },
  created() {
    this.initializeResumeData();
    this.loadJobExpectations();
  },
  watch: {
    userInfo: {
      handler() {
        this.initializeResumeData();
      },
      deep: true
    }
  },
  methods: {
    // 初始化 ResumeInfo 组件的数据
    initializeResumeData() {
      // 将 JSON 字符串转换为数组的辅助函数
      const parseJsonField = (field) => {
        if (!field) return []
        if (Array.isArray(field)) return field
        if (typeof field === 'string') {
          try {
            const parsed = JSON.parse(field)
            return Array.isArray(parsed) ? parsed : []
          } catch (e) {
            return []
          }
        }
        return []
      }
      
      // 从 userInfo 转换为 ResumeInfo 需要的格式
      this.resumeData = {
        ...this.userInfo,
        education_list: parseJsonField(this.userInfo.education_list),
        work_experience_list: parseJsonField(this.userInfo.work_experience_list),
        project_list: parseJsonField(this.userInfo.project_list),
        award_list: parseJsonField(this.userInfo.award_list),
      }
      console.log('resumeData:', this.resumeData);
      // 保存原始数据用于取消编辑
      this.originalResumeData = JSON.parse(JSON.stringify(this.resumeData))
    },
    
    // ResumeInfo 数据变化处理
    handleResumeDataChange(newData) {
      this.resumeData = newData
    },
    
    // 保存成功回调
    async handleSaveSuccess() {
      // 通知父组件刷新数据
      if (this.$parent && this.$parent.loadUserInfo) {
        await this.$parent.loadUserInfo()
        // 重新初始化数据
        this.$nextTick(() => {
          this.initializeResumeData()
        })
      }
    },
    
    formatExpectationSalary(expectation) {
      const start = expectation && expectation.expected_salary_start
      const end = expectation && expectation.expected_salary_end
      if (start && end) return `${start}k - ${end}k`
      if (start) return `${start}/天`
      return '未填写'
    },
  
    
    // 添加求职期望
    addJobExpectation() {
      this.editingExpectationIndex = null;
      this.currentEditingExpectation = null;
      this.editExpectationDialogVisible = true;
    },
    
    // 编辑求职期望
    async editJobExpectation(index) {
      this.editingExpectationIndex = index;
      const displayItem = this.jobExpectations[index];
      
      try {
        // 调用接口获取最新的详情数据
        if (displayItem && displayItem.id) {
          const response = await getUserExpectDetail({ id: displayItem.id });
          if (response.data.code === 1 && response.data.data) {
            const detailData = response.data.data;
            this.currentEditingExpectation = {
              ...detailData,
              desired_city: Array.isArray(detailData.desired_city) 
                ? detailData.desired_city 
                : (detailData.desired_city ? detailData.desired_city.split(',') : [])
            };
          } else {
            this.currentEditingExpectation = displayItem;
          }
        } else {
          this.currentEditingExpectation = displayItem;
        }
      } catch (error) {
        console.warn('获取求职期望详情失败:', error);
        this.currentEditingExpectation = displayItem;
      }
      
      this.editExpectationDialogVisible = true;
    },
    
    // 删除求职期望
    async deleteJobExpectation(index) {
      this.$confirm('确定要删除这个求职期望吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          const itemToDelete = this.jobExpectations[index];
          if (itemToDelete && itemToDelete.id) {
            // 调用删除API
            const response = await deleteUserExpect(itemToDelete.id);
            if (response.data.code === 1) {
              this.jobExpectations.splice(index, 1);
              this.$message.success('删除成功');
              // 重新加载数据
              await this.loadJobExpectations();
            } else {
              this.$message.error('删除失败：' + (response.data.msg || '未知错误'));
            }
          } else {
            // 如果没有ID，直接从前端删除
            this.jobExpectations.splice(index, 1);
            this.$message.success('删除成功');
          }
        } catch (error) {
          console.error('删除求职期望失败:', error);
          this.$message.error('删除失败，请重试');
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },
    
    // 公共组件保存回调，仅刷新列表并关闭
    async onExpectationSaved () {
      await this.loadJobExpectations()
      this.editExpectationDialogVisible = false
      this.currentEditingExpectation = null
      this.editingExpectationIndex = null
    },
    
    // 重置弹框状态
    resetExpectationDialog() {
      this.currentEditingExpectation = null;
      this.editingExpectationIndex = null;
    },

    // 获取求职类型标签
    getJobTypeLabel(jobType) {
      return getJobTypeLabel(jobType);
    },
    

    // 加载求职期望数据
    async loadJobExpectations() {
      try {
        const response = await getUserExpectList();
        if (response.data.code === 1 && response.data.data?.lists) {
          const expectData = response.data?.data?.lists;
          
          this.jobExpectations = expectData;
        }
      } catch (error) {
        console.warn('获取求职期望数据失败:', error);
      }
    },
  }
};
</script>

<style scoped lang="scss">
// 定义颜色变量
$text-color: #656587;

.resume-info-wrapper {
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.section-title {
  font-size: 18px;
  font-weight: bold;
  color: $text-color;
  margin: 0;
}
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.add-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 4px 8px;
  font-size: 14px;
  border-radius: 4px;
}

.add-btn:hover {
  background: transparent;
  border-color: transparent;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* 求职期望部分 */
.job-expectations-section {
  margin-bottom: 40px;
}

.expectations-content {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.expectation-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.expectation-info {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between; /* evenly distribute items */
  width: 100%;
  white-space: nowrap; /* keep content on one line */
  overflow: hidden; /* clip overflow if too long */
}

.expectation-item {
  display: flex;
  align-items: center;
  white-space: nowrap; /* prevent item wrapping */
  flex: 1 1 0; /* make each item take equal width */
  min-width: 0; /* allow inner text to shrink and ellipsis */
}

.expectation-label {
  color: $text-color;
  font-size: 14px;
  margin-right: 8px;
}

.expectation-value {
  color: $text-color;
  font-size: 14px;
  flex: 1 1 auto; /* fill remaining space within item */
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.expectation-actions {
  display: flex;
  margin-left: 16px;
}

.edit-expectation-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  padding: 4px 8px;
  font-size: 14px;
}

.edit-expectation-btn:hover {
  background: linear-gradient(90deg, #77BAFF 0%, #9C41FF 100%),
              linear-gradient(0deg, rgba(132, 172, 237, 0.4), rgba(132, 172, 237, 0.4));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.delete-expectation-btn {
  background: transparent;
  border-color: transparent;
  box-shadow: none;
  color: #F15D5D;
  padding: 4px 8px;
  font-size: 14px;
}

.delete-expectation-btn:hover {
  background: transparent;
  border-color: transparent;
  color: #F15D5D;
}

/* 对话框样式 */
.dialog-footer {
  text-align: right;
}

.dialog-footer .el-button {
  margin-left: 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .expectation-info {
    flex-wrap: wrap; /* allow wrap on small screens */
    white-space: normal;
    gap: 10px 16px;
  }
  
  .expectation-card {
    flex-direction: column;
    gap: 16px;
  }
  
  .expectation-actions {
    margin-left: 0;
    justify-content: flex-end;
  }
}

/* 图标样式 */
.el-icon-edit, .el-icon-plus, .el-icon-delete {
  margin-right: 4px;
}

/* 按钮图标对齐 */
.add-btn .el-icon-plus {
  vertical-align: middle;
}

/* 自定义按钮图标样式 */
.btn-icon {
  width: 14px;
  height: 14px;
  margin-right: 4px;
  vertical-align: middle;
}

.el-select{
  width: 100%
}

/* 薪资范围输入框样式 */
.row-compact {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .el-input {
    width: 136px; // 让input框更短
  }
}

.dash {
  color: #606266;
  font-weight: 500;
}
</style>